import { getEnv } from '../../config/Config';
import { eaFetch } from '../common/ApiUtils';

export async function getAccountConsumption(accountId, dispatch) {
  return eaFetch(
    dispatch,
    getEnv('REACT_APP_EDGE'),
    'GET',
    `account/${accountId}/consumption`
  );
}
